// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31en1","newExpiryDate":"styles_newExpiryDate__E9WMj","footer":"styles_footer__2yqyZ"};